"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RichTextInputClientSide;
var _reactRte = _interopRequireDefault(require("react-rte"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _htmlSanitizer = _interopRequireDefault(require("../../html-sanitizer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// note that the default includes code blocks etc.
// these are hard to handle in pdfkit (and pretty pointless for this system)
// and don't display on the start list correctly.
// So we now only display those that might possibly be of interest.
const TOOLBAR_CONFIG = {
  // Optionally specify the groups to display (displayed in the order listed).
  display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
  INLINE_STYLE_BUTTONS: [{
    label: 'Bold',
    style: 'BOLD',
    className: 'custom-css-class'
  }, {
    label: 'Italic',
    style: 'ITALIC'
  }, {
    label: 'Underline',
    style: 'UNDERLINE'
  }, {
    label: 'Strikethrough',
    style: 'STRIKETHROUGH'
  }],
  BLOCK_TYPE_DROPDOWN: [{
    label: 'Normal',
    style: 'unstyled'
  }, {
    label: 'Heading Large',
    style: 'header-one'
  }, {
    label: 'Heading Medium',
    style: 'header-two'
  }, {
    label: 'Heading Small',
    style: 'header-three'
  }],
  BLOCK_TYPE_BUTTONS: [{
    label: 'UL',
    style: 'unordered-list-item'
  }, {
    label: 'OL',
    style: 'ordered-list-item'
  }],
  BLOCK_ALIGNMENT_BUTTONS: []
};
const StyledRichTextEditor = (0, _styledComponents.default)(_reactRte.default)`
  .public-DraftEditor-content {
    min-height: 8em;
  }
`;
function RichTextInputClientSide(props) {
  const [state, setState] = _react.default.useState(() => ({
    richValue: _reactRte.default.createValueFromString(props.value.__html, 'html'),
    htmlValue: props.value.__html
  }));
  const onChange = richValue => {
    const htmlValue = (0, _htmlSanitizer.default)(richValue.toString('html'));
    setState({
      richValue,
      htmlValue
    });
    if (props.value.__html !== htmlValue) {
      props.onChange({
        __html: htmlValue
      });
    }
  };
  _react.default.useEffect(() => {
    if (props.value.__html !== state.htmlValue) {
      setState({
        richValue: _reactRte.default.createValueFromString(props.value.__html, 'html'),
        htmlValue: props.value.__html
      });
    }
  }, [props.value.__html, state.htmlValue]);
  return /*#__PURE__*/_react.default.createElement(StyledRichTextEditor, {
    className: props.className,
    value: state.richValue,
    onBlur: props.onBlur,
    onChange: onChange,
    toolbarConfig: TOOLBAR_CONFIG
  });
}